import React from 'react';
import CommentTextEditorV2 from '../../../../../../../common/CommentTextEditorV2';













const EditComment = ({
  comment: { commentId, metadata, assetIds },
  editorState,
  onUpdateContent,
  onChangeVisibility,
  onSave,
  toggleEditMode,
  onFilesChange,
  hideTimestamp,
  hideVisibility
}) => {
  const { timestamp, visibility } = JSON.parse(metadata || '{}');

  return (
    <div className="edit-comment">
      <CommentTextEditorV2
        assetIds={assetIds}
        commentId={commentId}
        editorState={editorState}
        onUpdateContent={onUpdateContent}
        timestamp={timestamp}
        visibility={visibility}
        onChangeVisibility={onChangeVisibility}
        onSave={onSave}
        onCancel={toggleEditMode}
        onFilesChange={onFilesChange}
        hideTimestamp={hideTimestamp}
        hideVisibility={hideVisibility} />

    </div>);

};

export default EditComment;